export default __webpack_public_path__ + "static/media/btn-zeroback-stop-de_de@2x.8c0d168d.png";